/**
 * Created by Administrador on 08/04/2016.
 */

(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('changePasswordCtrl', changePasswordCtrl);

    changePasswordCtrl.$inject = ['linkService','changePasswordService','Auth'];

    function changePasswordCtrl(linkService, changePasswordService,Auth){
        var vm = this;

        vm.setChangePassword = function(isValid){
            if (isValid) {
                changePasswordService.changePassword(vm.newPassword, vm.currentPassword)
                    .then(function(){
                        Auth.logout();
                        linkService.reloadRoute('home', null);
                    });
            }
        }
    }
})();
